import { LIMITS, validateDiagram } from './model';
export const MAX_SHARE_LENGTH = 12000;
async function bounded(stream, max) {
  const reader = stream.getReader(), parts = []; let size = 0;
  try { while (true) { const { value, done } = await reader.read(); if (done) break; size += value.length; if (size > max) throw new Error('Shared diagram is too large. Use a JSON file instead.'); parts.push(value); } }
  finally { await reader.cancel(); }
  const out = new Uint8Array(size); let offset = 0; for (const p of parts) { out.set(p, offset); offset += p.length; } return out;
}
export async function encodeShare(diagram, location = window.location) {
  if (!window.CompressionStream) throw new Error('Share links are unavailable in this browser. Export JSON instead.');
  const bytes = await bounded(new Blob([JSON.stringify(validateDiagram(diagram))]).stream().pipeThrough(new CompressionStream('gzip')), MAX_SHARE_LENGTH);
  const data = btoa(Array.from(bytes, b => String.fromCharCode(b)).join('')).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  const url = `${location.origin}${location.pathname}#diagram=${data}`;
  if (url.length > MAX_SHARE_LENGTH) throw new Error('Diagram is too large for a link. Export and share its JSON file instead.');
  return url;
}
export async function decodeShare(hash) {
  if (!hash.startsWith('#diagram=') || hash.length > MAX_SHARE_LENGTH || !/^[-\w]+$/.test(hash.slice(9))) throw new Error('Invalid diagram share link.');
  if (!window.DecompressionStream) throw new Error('This browser cannot open compressed diagrams. Request a JSON export.');
  try {
    const encoded = hash.slice(9).replace(/-/g, '+').replace(/_/g, '/');
    const bytes = Uint8Array.from(atob(encoded), c => c.charCodeAt(0));
    const raw = await bounded(new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip')), LIMITS.bytes);
    return validateDiagram(new TextDecoder('utf-8', { fatal: true }).decode(raw));
  } catch { throw new Error('Invalid or oversized shared diagram. Request a JSON export.'); }
}
